<div class="card-header-mini mb-0">
  <h3 class="card-title">{{widgetData.title}}</h3>
  <a *ngIf="widgetData.allLinkUrl" href="{{widgetData.allLinkUrl}}" target="{{widgetData.allLinkTarget}}" class="more-link">{{widgetData.allLinkText}}</a>
</div>

<mat-table *ngIf="grades.length && !loading && !isServerError" [dataSource]="grades" class="grades-table">
  <ng-container matColumnDef="assignmentText">
    <mat-cell *matCellDef="let element" class="assignment-text-td phone-tablet-td">
      <div class="phone-content">
        <div class="d-flex align-items-flex-start justify-content-space-between mb-05">
          {{ element.assignmentText }}
          <div *ngIf="!element.viewGrades" class="rating">{{ element.rating }}</div>
          <!-- <a *ngIf="element.viewGrades" href="#" class="nowrap-text">לצפייה בציונים</a> -->
        </div>

        <div class="type">
          {{ element.gradeType.name }}
        </div>
      </div>

      <div class="ellipsis-text d-phone-none">
        {{ element.assignmentText }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="type">
    <mat-cell *matCellDef="let element" class="d-phone-none">
      <div class="type" [ngStyle]="{'--state-color': element.gradeType.color}">
        {{ element.gradeType.name }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="gradeDate">
    <mat-cell *matCellDef="let element" class="date-td">
      <div class="date">{{ element.gradeDate | date:'dd.MM.yyyy' }}</div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-cell
      *matCellDef="let element"
      class="d-phone-none actions-td"
      [ngClass]="{ 'justify-content-space-between': !element.viewGrades }"
    >
      <div *ngIf="!element.viewGrades" class="rating">{{widgetData.gradeText}} <strong>{{ element.rating }}</strong></div>
      <!-- <a *ngIf="element.viewGrades" href="#" class="nowrap-text">לצפייה בציונים</a> -->

      <ng-container *ngIf="element.actions">
        <app-dropdown align="end" panelClass="table-dropdown" [width]="170">
          <button app-dropdown-trigger class="no-style table-menu">
            <mat-icon [svgIcon]="'dots'" class="table-menu-icon"></mat-icon>
          </button>
          <ng-container app-dropdown-content>
            <div class="dropdown-list">
              <ng-container *ngFor="let link of element.gradeType.links">
                <a class="dropdown-item" [href]="link.url">{{link.name}}</a>
              </ng-container>
            </div>
          </ng-container>
        </app-dropdown>
      </ng-container>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<div *ngIf="!grades.length && !loading && !isServerError">{{widgetData.noGradesText}}</div>

<mat-table *ngIf="loading && !isServerError" [dataSource]="grades" class="grades-table">
  <ng-container matColumnDef="assignmentText">
    <mat-cell *matCellDef="let element" class="assignment-text-td phone-tablet-td">
      <div class="phone-content">
        <div class="d-flex align-items-flex-start justify-content-space-between mb-05">
          <app-skeleton [type]="'text'" [symbolsCount]="20"/>
          <app-skeleton [type]="'text'" [symbolsCount]="2" class="rating"/>
        </div>
        <app-skeleton [type]="'text'" [symbolsCount]="10" class="type"/>
      </div>

      <div class="d-phone-none"><app-skeleton [type]="'text'" [symbolsCount]="14"/></div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="type">
    <mat-cell *matCellDef="let element" class="d-phone-none">
      <app-skeleton [type]="'text'" [symbolsCount]="8"/>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="gradeDate">
    <mat-cell *matCellDef="let element" class="date-td">
      <app-skeleton [type]="'text'" [symbolsCount]="8" class="date"/>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-cell
      *matCellDef="let element"
      class="d-phone-none actions-td justify-content-space-between"
    >
      <div class="rating">{{widgetData.gradeText}} <app-skeleton [type]="'text'" [symbolsCount]="2"/></div>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>


<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>